import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { CardMedia, CardMediaProps } from 'src/shared/components/Card';
import { withAspectRatio, withMediaFallback } from 'src/shared/hocs';

type EventMediaImageProps = CardMediaProps<'img', {}, 'as' | 'alt'>;

const EventMediaImage = (props: EventMediaImageProps) => {
  const { t } = useTranslation('common', { useSuspense: false });

  return <CardMedia {...props} alt={t('user-generated-image')!} as="img" />;
};

const EventMediaImageWithFallback = withMediaFallback(EventMediaImage);

const EventMediaImageWithAspectRatio = withAspectRatio(
  EventMediaImageWithFallback,
  ({
    currentTarget: { naturalHeight, naturalWidth },
  }: SyntheticEvent<HTMLImageElement>) => ({
    width: naturalWidth,
    height: naturalHeight,
  }),
  'onLoad',
);

export { EventMediaImageWithAspectRatio as EventMediaImage };
